import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { CtaButtonText } from 'site-modules/shared/components/native-ad/native-ad-components/cta-button-text/cta-button-text';

export function CtaUI({ ctaURL, ctaTarget = null, adClickTrackingListener, cta, showNarrowUnit = false }) {
  return (
    <a
      className="site-served-ad-link no-focus text-decoration-none"
      href={ctaURL}
      rel="noopener noreferrer"
      target={ctaTarget}
      onClick={adClickTrackingListener}
    >
      <span
        className={classnames(
          'btn btn-sm btn-outline-blue-50 text-blue-50 py-0_25 px-0_5 px-md-0_5 fw-bold mt-0 d-block rounded-8',
          {
            'size-16': !showNarrowUnit,
            'size-14': showNarrowUnit,
          }
        )}
      >
        <CtaButtonText text={cta} hideOpenIcon />
      </span>
    </a>
  );
}
CtaUI.propTypes = {
  ctaURL: PropTypes.string.isRequired,
  ctaTarget: PropTypes.string,
  adClickTrackingListener: PropTypes.func.isRequired,
  cta: PropTypes.string.isRequired,
  showNarrowUnit: PropTypes.bool,
};
